module.exports = __webpack_public_path__ + "static/img/037开江鱼美食节1.ea08a87.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/037开江鱼美食节1.jpg
// module id = Kfro
// module chunks = 0